<template>
  <label :class="['input', { 'input--disable': isDisabled }]" :for="id">
    <span v-if="label" :class="[checkout ? 'input__checkout' : 'input__title', required && 'input__required-mark']">{{
      label
    }}</span>
    <input
      :id="id"
      v-maska="mask"
      :name="name"
      :required="required"
      :autocomplete="autocomplete"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="isDisabled"
      :maxlength="maxlength"
      :class="['input__field', { 'input__field--error': hasError }]"
      :aria-label="accessibilityLabel"
      :aria-invalid="hasError"
      @input="onInput"
      @blur="onBlur"
    />
    <div v-if="errorMessage !== ''" class="input__error-container">
      <img src="../../../assets/images/warning.svg" class="warning-image" alt="" />
      <p role="alert" class="input__error-message">{{ errorMessage }}</p>
    </div>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: "AppInput",
  props: {
    maxlength: String,
    placeholder: String,
    label: String,
    accessibilityLabel: String,
    checkout: Boolean | "true",
    type: {
      type: String,
      default: "text"
    },
    modelValue: String,
    id: String,
    isDisabled: Boolean,
    hasError: Boolean,
    mask: String,
    name: String,
    autocomplete: String,
    errorMessage: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput(e) {
      if (this.maxlength && e.currentTarget.value.length > this.maxlength) {
        e.currentTarget.value = e.currentTarget.value.substr(0, this.maxlength);
      }

      this.$emit("update:modelValue", e.currentTarget.value);
    },
    onBlur(e) {
      if (this.type === "text" && !this.mask) {
        //Updates the view with the trimmed value
        e.currentTarget.value = e.currentTarget.value.trim();
        //Updates the model after trimming
        this.$emit("update:modelValue", e.currentTarget.value);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.input {
  display: block;
  margin-bottom: 15px;
  width: 100%;

  &__required-mark::after {
    content: "*";
  }

  &__field {
    box-sizing: border-box;
    width: 100%;
    height: 46px;
    text-indent: 10px;
    outline: none;
    background-color: $group-1-color-2;
    border-radius: 2px;
    border: solid 1px $border-color;
    font-size: 15px;

    &:focus {
      border: solid 2px $group-3-color-4;
      outline: none !important;
    }

    &--error {
      border-color: $error-color !important;
    }
  }

  &__title {
    display: block;
    font-family: $fontFamilyPrimary;
    color: $group-3-color-2;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.41;
    letter-spacing: normal;
  }

  &__checkout {
    font-size: 16px;
    font-family: $fontFamilyPrimary;
    color: $group-3-color-2;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 3.15;
    letter-spacing: normal;
  }

  &__error-container {
    display: flex;
    margin-top: -2px;
  }

  &__error-message {
    color: $error-color;
    margin-left: $spacer * 0.5;
  }

  &__warning-image {
    height: 23px;
    margin: 16px 8px 0 0;
  }

  &--disable {
    opacity: 0.4;
  }
}
</style>
